<template>
  <div class="main-container">

    <div class="container">
      <div class="column-75 page-middle">
        <h2>Congratulations!</h2> 
        <h4>You have successfully claimed your prize</h4>
      </div>
    </div>

  </div>
</template>

<script>
    import {elements_classes} from '../mixins/elements_classes'

    export default {
        name: "end_point",
        mixins: [elements_classes],
        data(){
            return{
                // this_page: 'end_point'
            }
        },
        computed: {
            this_page(){
                return this.$route.name
            }

        }
    }
</script>

<style scoped>
</style>